var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thêm mới camera",
        visible: _vm.dialogVisible,
        width: "1000px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "10vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "cameraData",
          attrs: {
            "label-width": "120px",
            model: _vm.cameraData,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Camera name", prop: "camName" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "Nhập tên camera" },
                model: {
                  value: _vm.cameraData.camName,
                  callback: function ($$v) {
                    _vm.$set(_vm.cameraData, "camName", $$v)
                  },
                  expression: "cameraData.camName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "DVR Name", prop: "idDvrcamera" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "Chọn DVR Name" },
                  on: {
                    change: function ($event) {
                      return _vm.changeDvrcamera()
                    },
                  },
                  model: {
                    value: _vm.cameraData.idDvrcamera,
                    callback: function ($$v) {
                      _vm.$set(_vm.cameraData, "idDvrcamera", $$v)
                    },
                    expression: "cameraData.idDvrcamera",
                  },
                },
                _vm._l(_vm.dvrcameraList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.id,
                      attrs: {
                        value: item.id,
                        label:
                          item.dvrType +
                          " - " +
                          item.dvrName +
                          " - " +
                          item.linkDvr,
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(item.dvrType) +
                            " - " +
                            _vm._s(item.dvrName) +
                            " - " +
                            _vm._s(item.linkDvr)
                        ),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "45%", display: "inline-block" },
              attrs: { label: "Camera chanel", prop: "camChanel" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập Camera chanel" },
                model: {
                  value: _vm.cameraData.camChanel,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.cameraData,
                      "camChanel",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "cameraData.camChanel",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: {
                width: "45%",
                display: "inline-block",
                float: "right",
              },
              attrs: { label: "Camera stream", prop: "camStream" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập Camera stream" },
                model: {
                  value: _vm.cameraData.camStream,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.cameraData,
                      "camStream",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "cameraData.camStream",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "45%", display: "inline-block" },
              attrs: { label: "OneCam chanel", prop: "camChanelOneCam" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập OneCam chanel" },
                model: {
                  value: _vm.cameraData.camChanelOneCam,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.cameraData,
                      "camChanelOneCam",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "cameraData.camChanelOneCam",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: {
                width: "45%",
                display: "inline-block",
                float: "right",
              },
              attrs: { label: "OneCam stream", prop: "camStreamOneCam" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập OneCam stream" },
                model: {
                  value: _vm.cameraData.camStreamOneCam,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.cameraData,
                      "camStreamOneCam",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "cameraData.camStreamOneCam",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Kích hoạt", prop: "camActive" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.cameraData.camActive,
                            callback: function ($$v) {
                              _vm.$set(_vm.cameraData, "camActive", $$v)
                            },
                            expression: "cameraData.camActive",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8, offset: "1" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: { label: "Giao thức phát" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.cameraData.outStream,
                            callback: function ($$v) {
                              _vm.$set(_vm.cameraData, "outStream", $$v)
                            },
                            expression: "cameraData.outStream",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "RTSP" } }, [
                            _vm._v("RTSP"),
                          ]),
                          _c("el-radio", { attrs: { label: "DVR" } }, [
                            _vm._v("DVR"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Bật âm thanh", prop: "openSound" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.cameraData.openSound,
                            callback: function ($$v) {
                              _vm.$set(_vm.cameraData, "openSound", $$v)
                            },
                            expression: "cameraData.openSound",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Link Camera", prop: "linkCam" } },
            [
              _vm.checkDisableLinkCam
                ? _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      placeholder: "Nhập link camera",
                    },
                    model: {
                      value: _vm.cameraData.linkCam,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.cameraData,
                          "linkCam",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "cameraData.linkCam",
                    },
                  })
                : _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      disabled: "",
                      placeholder: "Nhập link camera",
                    },
                    model: {
                      value: _vm.changeData,
                      callback: function ($$v) {
                        _vm.changeData =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "changeData",
                    },
                  }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Ghi chú", prop: "note" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "Nhập ghi chú",
                },
                model: {
                  value: _vm.cameraData.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.cameraData, "note", $$v)
                  },
                  expression: "cameraData.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("cameraData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("cameraData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }